import { useQuery } from '@tanstack/react-query';

import { Services } from '@ekhodealer/ekho-common';

import type { UseQueryResult } from '@tanstack/react-query';
import type { AiBdcSettings } from '../types';

import { apiClient } from '@config/server/apiClient';
import { configurationEndpoints } from '@config/server/apiEndpoints';

import { aiBdc } from './queryKeys';

/**
 * Fetches the ServicesProvider config and extracts the BDC settings.
 * The frontend type (AiBdcSettings) is a direct alias for BdcServiceConfig,
 * so no transformation is needed — just return the config object as-is.
 */
async function fetchBdcSettings(spId: string): Promise<AiBdcSettings | undefined> {
	const response = await apiClient.get<Record<string, unknown>>(
		configurationEndpoints.base(spId),
	);

	const cfg = response.data?.[Services.BDC] as AiBdcSettings | undefined;
	return cfg;
}

export const useGetAiBdcSettings = (spId: string): UseQueryResult<AiBdcSettings | undefined> =>
	useQuery({
		...aiBdc.settings(spId),
		queryFn: () => fetchBdcSettings(spId),
		staleTime: 5 * 60 * 1000,
	});
